<template>
  <div class="my-orders-page">
    <div class="shell">
      <div class="shell-inner">
        <div class="canvas" :style="canvasStyle">
          <div class="breadcrumb">
            <img :src="assets.breadcrumbIcon" alt="首页" class="breadcrumb-icon" />
            <span v-for="(item, index) in breadcrumbItems" :key="item" class="breadcrumb-text">
              {{ index === 0 ? item : " > " + item }}
            </span>
          </div>

          <div class="content">
            <OrderListPanel :back-icon="assets.backIcon" @back-home="goHome" @view-order="handleViewOrder" />
            <SidebarStage />
          </div>
        </div>
      </div>
    </div>

    <OrderDetailDialog :visible="detailDialogVisible" :order="currentOrder" :assets="assets"
      @close="handleCloseDetailDialog" />
  </div>
</template>

<script>
import { isLoggedIn } from "@/util/token-util.js";
import bus from "@/util/bus.js";
import SidebarStage from "@/views/home-confirm/components/SidebarStage.vue";
import OrderDetailDialog from "./components/OrderDetailDialog.vue";
import OrderListPanel from "./components/OrderListPanel.vue";

const PAGE_CANVAS_WIDTH = 1920;

export default {
  name: "MyOrdersPage",
  components: {
    OrderDetailDialog,
    OrderListPanel,
    SidebarStage,
  },
  data() {
    return {
      assets: {
        breadcrumbIcon: require("../../assets/my-orders/breadcrumb-icon.svg"),
        backIcon: require("../../assets/my-orders/back-icon.svg"),
        detailCloseIcon: require("../../assets/my-orders/detail-close-icon.svg"),
        detailActiveLine: require("../../assets/my-orders/detail-active-line.svg"),
        detailExpandIcon: require("../../assets/my-orders/detail-expand-icon.svg"),
        detailDivider: require("../../assets/my-orders/detail-divider.svg"),
        detailCollapsedShort: require("../../assets/my-orders/detail-collapsed-short.svg"),
        detailCollapsedLong: require("../../assets/my-orders/detail-collapsed-long.svg"),
      },
      breadcrumbItems: ["首页", "我的订单"],
      pageScale: 1,
      detailDialogVisible: false,
      currentOrder: {
        id: "",
        orderId: "",
        orderNo: "",
        caseReason: "",
        location: "",
        dateRange: "",
        detailCases: [],
      },
    };
  },
  computed: {
    canvasStyle() {
      return {
        zoom: this.pageScale,
      };
    },
  },
  mounted() {
    this.toggleViewportClass(true);
    this.updatePageScale();
    window.addEventListener("resize", this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    this.toggleViewportClass(false);
  },
  methods: {
    toggleViewportClass(shouldAdd) {
      const action = shouldAdd ? "add" : "remove";

      document.documentElement.classList[action]("page-scale-fit");
      document.body.classList[action]("page-scale-fit");
    },
    handleWindowResize() {
      this.updatePageScale();
    },
    updatePageScale() {
      const viewportWidth =
        window.innerWidth || document.documentElement.clientWidth;
      const nextScale = viewportWidth / PAGE_CANVAS_WIDTH;

      if (nextScale > 0 && nextScale !== this.pageScale) {
        this.pageScale = nextScale;
      }
    },
    ensureLoggedIn() {
      if (isLoggedIn()) {
        return true;
      }

      bus.$emit("openLoginDialog", "请登录后再查看订单");
      return false;
    },
    goHome() {
      this.$router.push("/");
    },
    async handleViewOrder(order) {
      if (!this.ensureLoggedIn()) {
        return;
      }

      this.currentOrder = {
        id: order.id || order.orderNo || "",
        orderId: order.orderId || "",
        orderNo: order.orderNo || order.id || "",
        caseReason: order.caseReason || "",
        location: order.location || "",
        dateRange: order.dateRange || "",
        detailCases: [],
      };
      this.detailDialogVisible = true;
    },
    handleCloseDetailDialog() {
      this.detailDialogVisible = false;
    },
  },
};
</script>

<style scoped>
.my-orders-page {
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  background: #ffffff;
}

.shell {
  width: 100%;
}

.shell-inner {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.canvas {
  flex: 0 0 auto;
  width: 1920px;
  padding-bottom: 80px;
  transform-origin: top left;
}

.breadcrumb {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 10px 0 10px 11px;
  background: #f7f7f7;
}

.breadcrumb-icon {
  width: 14px;
  height: 13px;
}

.breadcrumb-text {
  color: #666666;
  font-size: 14px;
  line-height: 20px;
}

.breadcrumb-text:first-of-type {
  margin-left: 10px;
}

.content {
  display: grid;
  grid-template-columns: 1128px 720px;
  column-gap: 37px;
  align-items: start;
  padding: 36px 35px 0;
}
</style>
<style scoped src="./index.mobile.css"></style>
